module.exports = __webpack_public_path__ + "img/card_img_five.206431bc.png";